<template>
  <el-dialog :visible.sync="visible" width="1152px" append-to-body :before-close="closedDialog">
    <div slot="title">
      <div class="title-left">详情</div>
    </div>
    <div class="info_box">
      <div class="title-text mb-16">{{data.announcementName}}</div>
      <div class="fx-c-center">
        <span class="title-right source-text mr-8">{{data.pubDate}}</span>
        <!-- <span class="source-text">来源：{{data.site}}</span> -->
        <el-link v-if="data.url" :href="data.url" type="primary" target="_blank">查看原文</el-link>
      </div>

      <div class="policy-text">
        <div v-html="data.rawContent"></div>
      </div>

    </div>
  </el-dialog>
</template>

<script>
import NewsTags from '@/views/industryChainNew/components/newsTags'
import popupMixin from '@/mixins/popup-mixin'
export default {
  name: 'DialogBidDetail',
  components: {
    NewsTags
  },
  mixins: [popupMixin],

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed: {
    sentiment() {
      const sensitivity = {
        neutral: '中性',
        positive: '正面',
        negative: '负面',
      }
      return sensitivity[this.data?.sensitivity || 'neutral']
    },
    thePercent() {
      if (this.data?.confidence !== null) {
        return this.data.confidence + '.00%'
      }
      return '--'
    }
  },
  methods: {
    formatText(text) {
      const reg = /(.*?)#&#/g
      text += '#&#'
      return text.replace(reg, (a, b) => {
        return `<p>${b}</p>`
      })
    }
  }
}
</script>

<style scoped lang="scss">
.policy-text {
  max-height: 300px;
  overflow-y: auto;
}
.title-left {
  display: flex;
  flex: 1;
  align-items: center;
}
.title-text {
  // color: inherit;
  // max-width: calc(100% - 250px);
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  // margin-right: 14px;
  // text-decoration: none;
}
</style>
